export default {
  QQ_APP_ID: "102042624",
  QQ_REDIRECT_URI: "https://im.timemory.xyz/oauth/login/qq",
};
